import { render, staticRenderFns } from "./AdminProductOrdersView.vue?vue&type=template&id=2bdd0238"
import script from "./AdminProductOrdersView.vue?vue&type=script&lang=ts"
export * from "./AdminProductOrdersView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports